import { ColumnTypeEnum, StitchColumnPropertiesModel, StitchReplicationMethod } from '@y42/json-schema';
import { DatasourceTableSettingsAirByteProperties } from '../datasource-table/datasource-table-settings.model';

export class StitchColumnsAgMappedModel {
  constructor(
    public is_automatic: boolean,
    public group: string | null = null,
    public tap_stream_id: string,
    public table_name: string,
    public row_count: number | null,
    public column_name: string,
    public type: ColumnTypeEnum,
    public key_properties: string[], // should be primary_keys
    public is_view?: boolean | null, // only relevant for SQL
    public replication_key_type?: ColumnTypeEnum,
    public replication_key?: string | null, // relevant for incremental
    public replication_method?: StitchReplicationMethod,
    public singerColumnPropertiesModel?: StitchColumnPropertiesModel,
    public airbyteIncrementalImportInfo?: DatasourceTableSettingsAirByteProperties,
  ) {}
}
